callpy_global.CUser = function()
{

    this.module_name = "User ";
    this.module_log_rang = 100;
    this.last_page_time = new Date().getTime();

    var _this = this;

    if (callpy_from_ls != true){
        this.selected_manager = 0;
        this.manager_request = false;
        this.flash_state = true;
        this.connected_to_rpx = false;
        this.last_visit_time = new Date().getTime();
    }else{
        this.selected_manager = callpy_storage.m_callpy.m_user.selected_manager;
        this.manager_request = callpy_storage.m_callpy.m_user.manager_request;
        this.flash_state = callpy_storage.m_callpy.m_user.flash_state;
        this.connected_to_rpx = true;
        this.last_visit_time = callpy_storage.m_callpy.m_user.last_visit_time;
    }

    this.init = function ()
    {
        //TODO: возможно, повесить обработчики вместо вызова при восстановлении из LS
        if (callpy_from_ls != true)
        m_callpy.create_callpy_block();//Блок где лежит чат и все что связано с callpy

        m_callpy.client_data.key = m_callpy.m_cookie.get_cookie("callpy_key");
        m_callpy.client_data.channel = m_callpy.m_cookie.get_cookie("callpy_chnl");
        if (m_callpy.initialize_data.set_new_key) {
            m_callpy.client_data.key = m_callpy.initialize_data.set_new_key;
            m_callpy.client_data.channel = m_callpy.initialize_data.channel;
            m_callpy.m_cookie.set_cookie("callpy_key", m_callpy.client_data.key, "Mon, 01-Jan-2101 00:00:00 GMT", '/');
            m_callpy.m_cookie.set_cookie("callpy_chnl", m_callpy.client_data.channel, "Mon, 01-Jan-2101 00:00:00 GMT", '/');
        }

        if (callpy_from_ls!=true){
            m_callpy.client_data.saveSysMes = 0;

            m_callpy.client_data.activePage = 0;
            m_callpy.client_data.clientInfo = m_callpy.initialize_data.clientInfo;
            m_callpy.client_data.department_id = m_callpy.initialize_data.init_data.department;
            if (m_callpy.initialize_data.init_data.update_active_state){
                m_callpy.client_data.activePage = 1;
                window.addEventListener("mousemove", m_callpy.m_control.onmousemove_handler, true);
            }
            m_callpy.client_data.dialogs = m_callpy.initialize_data.dialogs;
        }

        m_callpy.client_data.channel = m_callpy.initialize_data.channel; //шифруем канал: md5(siteId+"-"+clientId+"manager|client")

        if (m_callpy.initialize_data.init_data.manager_changed) m_callpy.client_data.peer_key = m_callpy.initialize_data.init_data.manager_changed.manager; //ответ инициализации сразу же возвращает id менеджера, если он назначен (для определения, выводить ли offline-заглушку)
        else if (m_callpy.initialize_data.init_data.online == false) m_callpy.client_data.peer_key = 0;

            if (m_callpy.initialize_data.init_data.online == false){
                m_callpy.managers_list = {}; //если клиент был в оффлайне, но данные могли восстанавливаться из LS - обнулим список менеджеров (если клиент был оффлайн, новый список придет из RLPX)
                //TODO: список консультантов (HTML) уже был восстановлен из LS, необходимо удалить
            }
            if (!m_callpy.client_data.peer_key && m_callpy.client_data.site_info["offline_lbl"] == "1") {
                //m_callpy.m_gui_chat.offline.off_lable({type: 'init'});
                //TODO: перенести в GUI
            }

        //обрабатываем остальные данные initialize_data (список менеджеров, ...)
        if (m_callpy.initialize_data.init_data.action == "register_client"){
            m_callpy.register_client({action: 'register_client', key: m_callpy.client_data.key, type: 1, channel: m_callpy.client_data.channel, site_id: m_callpy.initialize_data.init_data.site_id, far_id: 0});
        }

        //обработка регистрации менеджеров и manager_changed - в chat_init()

        m_callpy.m_control.init();
        m_callpy.m_flash.connect_to_fms();
        //UPDATED: в случае, если восстановление не из LS, зададим timeout для того, чтобы считать юзера подключенным к RPLX
        if (!_this.connected_to_rpx){
            setTimeout(function(){_this.connected_to_rpx = true;}, 3000);
        }

        if (m_callpy.client_data.site_info['userData']==1 && !m_callpy.client_data.social && m_callpy.client_data.site_info['blocked']==0) _this.ud();
        //UPDATED: здесь необходимо дождаться загрузки документа
        //document.addEventListener("DOMContentLoaded", function(){
            setTimeout(function(){
                console.log(localStorage["credentials"]);
                //также логин может содержаться в специальном элементе
                const callpyLgnElem = document.getElementById('callpy_lgn')
                const callpyLgnElemHTML = callpyLgnElem?.innerHTML??null
                //if ($jcallpy("#callpy_lgn") && $jcallpy("#callpy_lgn").html()!=undefined && $jcallpy("#callpy_lgn").html()!="")
                if (callpyLgnElemHTML&&callpyLgnElemHTML!=undefined && callpyLgnElemHTML!="") {
                    window.callpyLogin = callpyLgnElemHTML;//$jcallpy("#callpy_lgn").html();
                }
                //UPDATED: LocalStorage / Credentials
                if (localStorage["credentials"] && localStorage["credentials"].length > 0){
                    try{
                        var credentials = JSON.parse(localStorage["credentials"]);
                        if (credentials["email"] && credentials["email"].length > 0){
                            window.callpyLogin = credentials["email"];
                        }

                    }catch (e){

                    }
                }
                if (window.callpyLogin){
                    if ((m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.loginForm && m_callpy.client_data.clientInfo.formData.loginForm['login'] != window.callpyLogin) || (!m_callpy.client_data.clientInfo || !m_callpy.client_data.clientInfo.formData || !m_callpy.client_data.clientInfo.formData.loginForm)){

                        callpy_api.user("setLoginData", {login: window.callpyLogin});
                        //FIXED: запрос необходимо выполнять ПОСЛЕ того, как сервер Realplexor обработает подключение клиента. Введён settimeout (примерно 3 сек)
                        /*
                         setTimeout(function(){
                         $jcallpy.post(callpy_global.php_server + '/d/', {
                         action: "addFormData",
                         site_id: m_callpy.client_data.site_id,
                         key: m_callpy.client_data.key,
                         channel: m_callpy.client_data.channel,
                         site: m_callpy.client_data.site,
                         formType: "loginForm",
                         data: {login: window.callpyLogin}
                         }, function() {
                         _this.formData({formType: "loginForm", data: {login: window.callpyLogin}});
                         });
                         }, 3000);
                         */

                    }
                }
            }, 5000);

        //});

        //TODO: хардкод, вынести в сценарии
        if (m_callpy.client_data.site_id == 18313){
            if (m_callpy.m_storage.restoreInIE){
                //TODO: фикс для IE
                document.getElementById("callpy").style.display = "none";
            }
            /*
            var d = new Date();
            if (!localStorage["stats_"+d.getDate()+"_"+d.getMonth()+"_"+d.getFullYear()] && m_callpy.client_data.peer_key && !callpy_api.manager.isBusyWithCall){
                localStorage["stats_"+d.getDate()+"_"+d.getMonth()+"_"+d.getFullYear()] = 1;
                m_callpy.m_bridge.to_fms(
                    m_callpy.m_message.create_message("update_stats", {"stat": "label_show"}), function(response){

                    });
            }
            */
            /*
            if (callpy_api.manager.isBusyWithCall){
                //начальная инициализация при загрузке - менеджер уже в звонке
                $jcallpy("#callpy_wrapper").hide();
            }else{
                $jcallpy("#callpy_wrapper").show();
            }
            */
            callpy_api.events('callStart', function(){
                //$jcallpy("#callpy_wrapper").hide();
                //if ($jcallpy(".chats").length) $jcallpy(".chats").show();
                //if ($jcallpy(".lt-widget-wrap").length) $jcallpy(".lt-widget-wrap").show();
                //if ($jcallpy(".lt-label").length) $jcallpy(".lt-label").show();
            });
            callpy_api.events('callEnd', function(){
                //$jcallpy("#callpy_wrapper").show();
                //if ($jcallpy(".chats").length) $jcallpy(".chats").hide();
                //if ($jcallpy(".lt-widget-wrap").length) $jcallpy(".lt-widget-wrap").hide();
                //if ($jcallpy(".lt-label").length) $jcallpy(".lt-label").hide();
                /*
                var d = new Date();
                if (!localStorage["stats_"+d.getDate()+"_"+d.getMonth()+"_"+d.getFullYear()]){
                    localStorage["stats_"+d.getDate()+"_"+d.getMonth()+"_"+d.getFullYear()] = 1;
                    m_callpy.m_bridge.to_fms(
                        m_callpy.m_message.create_message("update_stats", {"stat": "label_show"}), function(response){

                        });
                }
                */
            });
        }


    };

    this.change_manager = function (manager)
    {
        if (!manager)
        {
            if (!_this.manager_request)
            {
                _this.manager_request = true;
                m_callpy.m_bridge.to_php(
                    m_callpy.m_message.create_message("change_manager", {
                        "user": m_callpy.client_data.key,
                        "manager": "",
                        "site": m_callpy.client_data.site_id,
                        "domain": m_callpy.client_data.site,
                        "statusData": "1" + ($jcallpy('#callpy_lableCont').attr('data-status') == "off"?"1":"0") + (m_callpy.m_chat.history.length?"1":"0")
                    }));
            }
        }
        else
        {
            m_callpy.m_bridge.to_php(
                m_callpy.m_message.create_message("change_manager", {
                    "user": m_callpy.client_data.key,
                    "manager": manager,
                    "site": m_callpy.client_data.site_id,
                    "domain": m_callpy.client_data.site,
                    "statusData": "1" + ($jcallpy('#callpy_lableCont').attr('data-status') == "off"?"1":"0") + (m_callpy.m_chat.history.length?"1":"0")
                }));
        }
    };

    this.getDepartment = function(fltrs, clientData, defaultId)
    {
        var filters = {}, department_id = defaultId, filter, match, match_filter, regexp, values;
        for (var i=0; i<fltrs.length; i++){
            if (!filters[fltrs[i]["department_id"]]) filters[fltrs[i]["department_id"]] = [];
            filters[fltrs[i]["department_id"]].push(fltrs[i]);
        }
        for (var key in filters){
            if (!filters.hasOwnProperty(key)) continue;
            filter = filters[key];
            match = true;
            for (var i=0; i<filter.length; i++){
                match_filter = false;
                switch (filter[i]["type"]){
                    case "url":
                        switch (filter[i]["term"]){
                            case "includes":
                                values = filter[i]["value"].split("\n");
                                for (var j=0; j<values.length; j++){
                                    regexp = new RegExp(m_callpy.preg_quote(values[j]), 'i');
                                    if (clientData["referer"].match(regexp)) {
                                        match_filter = true;
                                        break;
                                    }
                                }
                                break;
                        }
                        break;
                }
                if (!match_filter){
                    match = false;
                    break;
                }
            }
            if (match){
                department_id = key;
                break;
            }
        }
        return department_id;
    }

    this.register_complete = function(data)
    {
        m_callpy.client_data.key = data["key"];
        m_callpy.client_data.far_id = data["far_id"];
        m_callpy.client_data.site_id = data["site_id"];
        m_callpy.client_data.channel = data["channel"];

    };


    this.bridge_ready = function ()
    {

    };

    this.select_manager = function (key)
    {
        if (!key)
        {
            key = 0;
        }

        if (_this.selected_manager != key)
        {
            _this.selected_manager = key;
            //m_callpy.m_storage.saveData();
            m_callpy.set_peer();
            //если не из ЛС, значит, это первая загрузка, и callpy_consultant('set') вызовется при инициализации чата
            //$jcallpy.callpy_consultant('set');

            /*if (m_callpy.m_gui_chat)
            {*/
            /*
                if (key == 0)
                {
                    //Удалить ярлык
                    //m_callpy.m_gui_chat.change_consultant({'name': '', 'id':'delete'});
                    //$jcallpy.callpy_consultant('delete');
                    if (!callpy_from_ls) $jcallpy.callpy_consultant('set');
                }
                else
                {
                    if (!callpy_from_ls) $jcallpy.callpy_consultant('set');
                }
            */
            //}
        } else m_callpy.set_peer();

        m_callpy.m_storage.saveData();
    };

    this.add_manager = function (data, tmp)
    {
        //добавляем менеджера только если его еще нет (возможно, он уже есть, была открыта другая вкладка, которая сгенерировала сообщение о новом менеджере (т.к. на ней менеджера еще нет))
        if (tmp == false){
            if (data["key"] == _this.selected_manager)
            {
                _this.select_manager(data["key"]);
            }

            //if (m_callpy.m_gui_chat)
            //{
                /*
                m_callpy.m_gui_chat.add_consultant(
                    {id: data["key"], name: data["name"], descr: "Консультант", online: 1}
                );
                */
            //}
            //$jcallpy.callpy_flat('_create_departments'); //old
            $jcallpy.callpy_departments('_create_select');
            $jcallpy.callpy_departments('_events');

        }

    };

    this.remove_manager = function (data)
    {
        //TODO GUI: удаляем консультанта из списка
        //m_callpy.m_gui_chat.remove_consultant(data["key"]);
        //$jcallpy.callpy_flat('_create_departments'); //old
        $jcallpy.callpy_departments('_create_select');
        $jcallpy.callpy_departments('_events');
    };

    this.manager_changed = function (data)
    {
        var managerOn = false, managerOff = false;
        if (m_callpy.client_data.key == data["user"] && (m_callpy.m_user.selected_manager != data["manager"] || (data["department_id"] && data["department_id"] != m_callpy.client_data.department_id)))
        {
            if (data["department_id"] && data["department_id"] != m_callpy.client_data.department_id){
                m_callpy.client_data.department_id = data["department_id"];
                //m_callpy.m_storage.saveData();
                //$jcallpy.callpy_departments('_set_select_department');
                m_callpy.m_autos.checkAllConditions({entering_dprt: data["department_id"]});
            }
            //UPDATED: если включена настройка отдельной переписки между отделами, то необходимо стереть всю текущую и вызвать функцию заново
            if (m_callpy.client_data.site_info["s_dividedDepsChats"] == 1){
                document.getElementById("callpy_box_for_message").innerHTML = "";
                m_callpy.m_chat.set_message_history({history: m_callpy.m_chat.history});
                //console.log("changed history department");
                //m_callpy.m_storage.saveHtml();
            }
            m_callpy.client_data.activePage = 0;
            if (m_callpy.initialize_data.init_data.update_active_state) m_callpy.client_data.activePage = 1;
            //запишем данные о activePage в ЛС, чтобы корректно восстанавливались, например, на новой вкладке
            _this.manager_request = false;
            if (!_this.selected_manager){ //консультанта не было, возможно, необходимо будет вывести автоприветствие

                //Если число секунд 0, автоприветствие выключено администратором
                //if (parseInt(m_callpy.client_data.site_info["autogreet"])>0) {

                    //также проверим, есть ли вообще консультант (эта функция может вызваться, когда консультант уходит, тогда передается 0)
                    if (data["manager"]){

                        //callpy_api.events._fireCallback("managerOn");
                        managerOn = true;
                        //для предотвращения обработки автоприветствия несколькими вкладками, а также callpy_am чистится только если страница загружается не из LS
                        //обновим "время входа" и инициируем автоприветствия (те, которые остались)
                        localStorage.setItem("callpy_enterTime", new Date().getTime());
                        //сбросим текущие счетчики, если они есть
                        if (m_callpy.m_activity.automessageTimer){
                            for (var key in m_callpy.m_activity.automessageTimer){
                                clearTimeout(m_callpy.m_activity.automessageTimer[key]);
                            }
                        }
                        m_callpy.m_activity.automessage_init();
                        /*
                        if (!localStorage.getItem("callpy_am")){
                            clearTimeout(m_callpy.m_activity.automessageTimer);
                            m_callpy.m_activity.automessageTimer = setTimeout(m_callpy.m_activity.automessage, parseInt(m_callpy.client_data.site_info["seconds"]*1000));
                        }
                        */

                    }

                //}

            }else{
                //if (!data["manager"]) callpy_api.events._fireCallback("managerOff");
                if (!data["manager"]) managerOff = true;
            }
            //TODO: RT, убрать
            if (m_callpy.client_data.site_id == 19069){
                if (data["manager"] && data["manager"] != 1){

                    $jcallpy("li[data-name='call']").css('pointer-events', 'all');
                    $jcallpy("li[data-name='call']>button").css('pointer-events', 'all');
                    $jcallpy("li[data-name='call']").css('opacity', '1');

                    $jcallpy("#callpy_button_callback").css('pointer-events', 'all');
                    $jcallpy("#callpy_button_callback").css('opacity', '1');

                }else{
                    //назначен бот или никто, отключаем звонок
                    $jcallpy("li[data-name='call']").css('pointer-events', 'none');
                    $jcallpy("li[data-name='call']>button").css('pointer-events', 'none');
                    $jcallpy("li[data-name='call']").css('opacity', '0.5');

                    $jcallpy("#callpy_button_callback").css('pointer-events', 'none');
                    $jcallpy("#callpy_button_callback").css('opacity', '0.5');
                }
            }
            if (m_callpy.client_data.site_id == 18313){
                //TODO: хардкод, убрать впоследствии
                if (data["manager"]){
                    if ($jcallpy(".chats").length) $jcallpy(".chats").hide();
                    if ($jcallpy(".lt-widget-wrap").length) $jcallpy(".lt-widget-wrap").hide();
                    if ($jcallpy(".lt-label").length) $jcallpy(".lt-label").hide();
                }
                if (!data["manager"]){
                    if ($jcallpy(".chats").length) $jcallpy(".chats").show();
                    if ($jcallpy(".lt-widget-wrap").length) $jcallpy(".lt-widget-wrap").show();
                    if ($jcallpy(".lt-label").length) $jcallpy(".lt-label").show();
                }

            }
            m_callpy.m_user.select_manager(data["manager"]);
            if (managerOn) callpy_api.events._fireCallback("managerOn");
            if (managerOff) callpy_api.events._fireCallback("managerOff");
            if (data["notify"]){ //клиента "передали", сообщение в чат
                //TODO GUI: системное сообщение в чат о передаче другому менеджеру
            }
        }else{
            $jcallpy.callpy_consultant('set');
        }
        m_callpy.m_autos.checkAllConditions();
    };

    this.get_user_page = function ()
    {
        //fix window.location.origin for ie
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
        }
        //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("set_origin", {0: window.location.origin, 1: document.cookie, 2: m_callpy.m_flash.webRTCsupp}));
        //TODO: условие активной вкладки убрал, т.к. этот запрос будет довольно редким (когда только в оперативке нет данных по этому клиенту)
        //if (m_callpy.m_storage.activeTab == true){ //генерируем сообщение go_url только активной вкладкой
            //TODO: NEW CHAT: изменить проверку
            //if ($jcallpy.callpy_call('status').status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: m_callpy.m_control.get_top_scroll()});
            if (m_callpy.m_chat.call_status != "call")m_callpy.m_bridge.to_peer({action: "go_url", url: window.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: m_callpy.m_control.get_top_scroll()});
            else m_callpy.m_bridge.to_peer({action: "go_url", url: document.getElementById("callpy_iframeid").contentWindow.location.href, width: $jcallpy(document).width(), height: $jcallpy(document).height(), scroll: document.getElementById('callpy_iframeid').contentWindow.m_callpy.m_control.get_top_scroll()});
        //}
    };

    this.update_active_state = function(data)
    {
        m_callpy.client_data.activePage = parseInt(data["activePage"]);
        if (m_callpy.client_data.activePage == 1 && ($jcallpy.callpy_select().length || $jcallpy.callpy_pointer().length) && m_callpy.m_storage.activeTab){ //менеджер выбрал клиента: если у клиента на странице есть элементы, отправляем менеджеру
            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("set_elements", {
                "elements": {
                    selects: $jcallpy.callpy_select(),
                    pointers: $jcallpy.callpy_pointer()
                }
            }));
        }
        if (m_callpy.client_data.activePage == 1){
            window.addEventListener("mousemove", m_callpy.m_control.onmousemove_handler, true);
        }else{
            window.removeEventListener("mousemove", m_callpy.m_control.onmousemove_handler);
        }
        //запишем данные о activePage в ЛС, чтобы корректно восстанавливались, например, на новой вкладке
        m_callpy.m_storage.saveData();
    }

    this.go_url = function (url)
    {
        //UPDATED:
        //Теперь сообщение go_url приходит от консультанта при загрузке фрейма в панели в случае удалённого управления. Здесь необходимо сравнить переданный URL
        //с текущей страницей, и осуществить переход, если URL не совпадают
        if (m_callpy.client_data.activePage == 1 && (window.location.href != url) && localStorage["callpy_control_flag"] == 2){
            /*
            if (url.split("#")[0] == window.location.href.split("#")[0]){
                //если совпадает всё, что до хеша, а хеш, возможно, отличается
                window.location.href = "";
            }
            */
            window.location.href = url;
        }
    };

    this.disconnect_request = function()
    {
        //свернут или развернут чат
        /*
        var t = $jcallpy('#callpy_lableCont');
        if (t){
            t = (t.attr('data-status')=='off'?1:0);
        }else t=0;
        */
        var t = $jcallpy.callpy_status('api').visible == true?1:0;

        var fEnter = localStorage.getItem("callpy_fEnt");
        if (!fEnter){
            fEnter = Math.floor(new Date().getTime()/1000);
            localStorage.setItem("callpy_fEnt", fEnter);
        }
        var visits = localStorage.getItem("callpy_vsts");
        if (!visits) visits = 0;
        visits++;
        localStorage.setItem("callpy_vsts", visits);

        //fix window.location.origin for ie
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
        }
        m_callpy.m_bridge.to_php(
            m_callpy.m_message.create_message("disconnect_request", {
                "site_url": m_callpy.client_data.site,
                "site_id": m_callpy.client_data.site_id,
                "key": m_callpy.client_data.key,
                "type": m_callpy.client_data.type,
                "referer": encodeURIComponent(window.location.href),
                "hidden": (document.mozHidden || document.msHidden || document.webkitHidden || document.hidden?1:0),
                "webRTCsupp": ((window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection) && (navigator.userAgent.indexOf("Chrome/") != -1 || navigator.getUserMedia || navigator.mozGetUserMedia || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia))?1:0),
                "origin": encodeURIComponent(window.location.origin),
                "chatWindowStatus": t,
                "manager": m_callpy.client_data.peer_key,
                "browser": navigator.userAgent,
                "width": $jcallpy(window).width(),
                "enter": fEnter,
                "title": document.title,
                "visits": visits
            }));
    }

    this.disconnect_answer = function (data)
    {
        //ответ сервера на запрос disconnect_request (здесь список менеджеров и назначенный менеджер, если менеджеры вообще есть на сайте)
        //сначала необходимо выполнить unregister_client для всех существующих менеджеров
        for (var keys in m_callpy.managers_list) {
            if (m_callpy.managers_list[keys]) m_callpy.unregister_client({action: "unregister_client", key: m_callpy.managers_list[keys].key, type: 2});
        }
        //чтобы корректно отработала manager_changed, сбросим текущего выбранного менеджера (он может совпадать с вновь назначенным)
        //FIXED: в том числе, нельзя выставить 0, т.к. если менеджер отсутствует, это должно выставиться в manager_changed
        m_callpy.m_user.selected_manager = -1;
        if (data["manager"]){
            for (var i=0;i<data["managers"].length;i++){
                m_callpy.register_client(data["managers"][i]);
            }
            m_callpy.manager_changed({action: "manager_changed", user: m_callpy.client_data.key, manager: data["manager"]});
        }else{
            if (data["managers"]){
                for (var i=0;i<data["managers"].length;i++){
                    m_callpy.register_client(data["managers"][i]);
                }
            }
            //на сайте нет больше менеджеров - удалим ярлык
            m_callpy.manager_changed({action: "manager_changed", user: m_callpy.client_data.key, manager: 0});
        }

        m_callpy.m_storage.saveData();
    }

    this.replacePatterns = function (str)
    {
        //реплейсы для данных консультанта (если он назначен)
        var replaces = ["name", "subname", "position", "phone", "mail"];
        var result = str;
        for (var i=0; i<replaces.length; i++) result = result.replace(new RegExp("%"+replaces[i]+"%", "g"), (m_callpy.client_data.peer_key && m_callpy.managers_list[m_callpy.client_data.peer_key])?m_callpy.managers_list[m_callpy.client_data.peer_key][replaces[i]]:"");
        //реплейсы для данных клента
        var replaces_client = ["clientName", "client_city", "client_region", "client_country", "client_browser"];
        for (var i=0; i<replaces_client.length; i++) result = result.replace(new RegExp("%"+replaces_client[i]+"%", "g"), callpy_api.user[replaces_client[i]]);
        //специфичные паттерны
        replaces = [
            {pattern: "%link1%", replace: ""},
            {pattern: "%br%", replace: "<br>"},
            {pattern: "\\n", replace: "<br>"},
            {pattern: "%id%", replace: m_callpy.client_data.key},
            {pattern: "%hellodaytime%", replace: (new Date().getHours() < 5 ? _("Доброй ночи") : (new Date().getHours() < 12 ? _("Доброго утра") : (new Date().getHours() < 18 ? _("Добрый день") : _("Добрый вечер"))))}
        ];
        for (var i=0; i<replaces.length; i++) result = result.replace(new RegExp(replaces[i].pattern, "g"), replaces[i].replace);
        return result;
    };

    this.ud = function()
    {
        return;
        //UPDATED: проверка, если вктрекер настроен только на определённых страницах
        var exists = false, uriDecoded;
        if (m_callpy.client_data.site_info.userDataPages && m_callpy.client_data.site_info.userDataPages.length>0){
            var urls = m_callpy.client_data.site_info.userDataPages.split('|');
            for (var j=0; j<urls.length; j++){
                try{
                    uriDecoded = decodeURIComponent(urls[j]);
                }catch (e){
                    continue;
                }
                if ((urls[j].length>1 && location.pathname.indexOf(uriDecoded)>=0) || (urls[j] == location.pathname)){
                    exists = true;
                    break;
                }
            }
        }else{
           exists = true;
        }

        if (exists){
            var s=document.createElement('script');
            //s.src="//proxy.lsd.by/m_callpy.php?h="+encodeURIComponent(window.location.host);
            s.src="//kallpy.com/getVKid/watch.php?domain="+encodeURIComponent(window.location.host)+"&protocol="+window.location.protocol;
            document.getElementsByTagName('head')[0].appendChild(s);
            m_callpy.client_data.social = true;
            m_callpy.m_storage.saveData();

            window.addEventListener("message",function(e){
                var d = e.data;
                if (d.match("userData:")) {
                    var ud = d.replace("userData:", "");
                    _this.userData($jcallpy.parseJSON(ud));
                };
            }, false);

        }
    }

    this.userData = function (data)
    {
        //TODO: условие показа: ранее не показывали, либо данные не совпадают

        if (data.last_name && data.first_name && data.vk_id){
            if (!m_callpy.client_data.clientInfo || !m_callpy.client_data.clientInfo.userData || !m_callpy.client_data.clientInfo.userData.vk_id || m_callpy.client_data.clientInfo.userData.vk_id != data["vk_id"]) {

                m_callpy.client_data.clientInfo.userData = data;
                $jcallpy.callpy_forms('_social_show');
                //m_callpy.m_storage.saveData();
                //m_callpy.m_storage.saveSyncData(true);
            }

            setTimeout(function(){
                //m_callpy.m_bridge.to_peer({action: "userData", data: data});
                if (!m_callpy.client_data.peer_key) m_callpy.m_bridge.to_fms({action: "userData", data: data, domain: m_callpy.client_data.site});
                else m_callpy.m_bridge.to_peer({action: "userData", data: data});
            }, 3500);
        }
    }

    this.formData = function (data)
    {
        switch (data['formType']){
            case "contactForm":
                if (!m_callpy.client_data.clientInfo.formData) m_callpy.client_data.clientInfo.formData = {};
                m_callpy.client_data.clientInfo.formData.contactForm = data["data"];
                //UPDATED: соответствующее событие
                callpy_api.events._fireCallback('contactForm');
                m_callpy.m_autos.checkAllConditions();
                break;
            case "departmentForm":
                if (!m_callpy.client_data.clientInfo.formData) m_callpy.client_data.clientInfo.formData = {};
                if (!m_callpy.client_data.clientInfo.formData.departmentForm) m_callpy.client_data.clientInfo.formData.departmentForm = {};
                m_callpy.client_data.clientInfo.formData.departmentForm[m_callpy.client_data.department_id] = data["data"];
                //UPDATED: соответствующее событие
                callpy_api.events._fireCallback('contactForm', m_callpy.client_data.department_id);
                m_callpy.m_autos.checkAllConditions();
                break;
            case "siteForm":
                if (!m_callpy.client_data.clientInfo.formData) m_callpy.client_data.clientInfo.formData = {};
                if (!m_callpy.client_data.clientInfo.formData.siteForm) m_callpy.client_data.clientInfo.formData.siteForm = {};
                m_callpy.client_data.clientInfo.formData.siteForm[data["form_id"]] = data["data"];
                //UPDATED: соответствующее событие
                callpy_api.events._fireCallback('contactForm', m_callpy.client_data.department_id);
                m_callpy.m_autos.checkAllConditions();
                break;
            case "loginForm":
                if (!m_callpy.client_data.clientInfo.formData) m_callpy.client_data.clientInfo.formData = {};
                m_callpy.client_data.clientInfo.formData.loginForm = data["data"];
                break;
            case "customForm":
                if (!m_callpy.client_data.clientInfo.formData) m_callpy.client_data.clientInfo.formData = {};
                if (!m_callpy.client_data.clientInfo.formData.customForm) m_callpy.client_data.clientInfo.formData.customForm = {};
                if (typeof data["data"] == "string"){ //в случае, если объект закриптован, запишем строку в массив с закриптованными строками
                    /*
                    Здесь необходимо отметить, что соответствующее свойство хранит лишь последнюю переданную закриптованную строку с данными, а не закриптованные данные целиком
                    Это упрощение сделано для того, чтобы при добавлении закриптованных данных заново на стороне сервера не шифровать весь объект закриптованных свойств
                    Если на стороне клиента необходимо будет иметь корректный закриптованный объект со всеми свойствами без дополнительных запросов для его получения,
                    алгоритм работы необходимо будет переписать
                     */
                    m_callpy.client_data.clientInfo.formData.customForm["CallpyEncryptedString"] = data["data"];
                }else{
                    for (var key in data["data"]){
                        m_callpy.client_data.clientInfo.formData.customForm[key] = data["data"][key];
                    }
                }
                break;
        }
        m_callpy.m_storage.saveData();
        m_callpy.m_storage.saveSyncData(true);
        //UPDATED: для GA
        if (window.gtag){
            window.gtag('event', 'form_filling', {
                'event_category': 'callpy',
                'event_label': data["formType"]
            });
        } else if (window.ga){
            //событие "заполнение форм (контактов/etc)"
            window.ga('send', 'event', 'callpy', 'form_filling', data["formType"]);
        }
    };

    this.fillForm = function (data)
    {
        //UPDATED: проверка на одновременные вызовы показа формы сразу после заполнения
        //необходимо, например, для конструктора сценариев
        if (m_callpy.m_autos && m_callpy.m_autos.showButtonFormTimer && m_callpy.m_autos.showButtonFormTimer[data['form_id']]){
            if (new Date().getTime() - m_callpy.m_autos.showButtonFormTimer[data['form_id']] < m_callpy.m_autos.buttonFormTimerSec){
                return;
            }
        }
        if (data['form_id'] != 'rate'){
            //вызов GUI для отрисовки формы с id data["form_id"]
            $jcallpy.callpy_message('_createForm', data['form_id']);
        }else{
            //форма оценки
            callpy_gui.rate('showForm');
        }

        if (m_callpy.client_data.saveSysMes){
            //только если стоит флаг о записи системных сообщений, чтобы не грузить БД
            //для установки флага требуется какое-либо взаимодействие с консультантом - чат, звонок
            m_callpy.m_bridge.to_fms({
                action: "save_sys_log",
                peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0),
                site: m_callpy.client_data.site,
                domain: m_callpy.client_data.site,
                messages: JSON.stringify([{type: "fillForm", message: data['form_id'] != 'rate' ? m_callpy.client_data.site_info.forms[data["form_id"]].name : _("Форма оценки диалога"), timestamp: 1}])
            },function(data){

            });

        }


    };

    /**
     * UPDATED: ранее метод изменял данные формы отделов, теперь данные просто формы, название осталось старое
     * @param data
     */

    this.depFieldAdded = function(data)
    {
        /*
        if (m_callpy.client_data.site_info.departments && m_callpy.client_data.site_info.departments[data["department_id"]]){
            if (!m_callpy.client_data.site_info.departments[data["department_id"]].fields){
                m_callpy.client_data.site_info.departments[data["department_id"]].fields = [];
            }
            m_callpy.client_data.site_info.departments[data["department_id"]].fields.push(data["field"]);
        }
        */
        if (m_callpy.client_data.site_info.forms && m_callpy.client_data.site_info.forms[data["form_id"]]){
            if (!m_callpy.client_data.site_info.forms[data["form_id"]].fields){
                m_callpy.client_data.site_info.forms[data["form_id"]].fields = [];
            }
            m_callpy.client_data.site_info.forms[data["form_id"]].fields.push(data["field"]);
        }

        /*if ($jcallpy.callpy_departments('_isForm')) {
            $jcallpy.callpy_departments('_create_form');
        }*/
        m_callpy.m_storage.saveData();
    };

    this.depFieldChanged = function(data)
    {
        if (m_callpy.client_data.site_info.forms && m_callpy.client_data.site_info.forms[data["form_id"]] && m_callpy.client_data.site_info.forms[data["form_id"]].fields){
            for (var i=0; i<m_callpy.client_data.site_info.forms[data["form_id"]].fields.length; i++){
                if (m_callpy.client_data.site_info.forms[data["form_id"]].fields[i] == data["field_id"]){
                    for (var key in data["data"]){
                        m_callpy.client_data.site_info.forms[data["form_id"]].fields[i][key] = data["data"][key];
                    }
                    break;
                }
            }
        }

        /*if ($jcallpy.callpy_departments('_isForm')) {
            $jcallpy.callpy_departments('_create_form');
        }*/
        m_callpy.m_storage.saveData();
    };

    this.depFormChanged = function(data)
    {
        /*
        if (m_callpy.client_data.site_info.departments && m_callpy.client_data.site_info.departments[data["department_id"]]){
            if (data["form_name"]){
                m_callpy.client_data.site_info.departments[data["department_id"]].form_name = data["form_name"];
            }
        }
        */
        if (m_callpy.client_data.site_info.forms && m_callpy.client_data.site_info.forms[data["form_id"]]){
            if (data["form_name"]){
                m_callpy.client_data.site_info.forms[data["form_id"]].name = data["form_name"];
            }
            if (data["additional_data"]){
                m_callpy.client_data.site_info.forms[data["form_id"]].additional_data = data["additional_data"];
            }
        }
        /*if ($jcallpy.callpy_departments('_isForm')) {
            $jcallpy.callpy_departments('_create_form');
        }*/
        m_callpy.m_storage.saveData();
    };

    this.depFormAdded = function (data)
    {
        if (!m_callpy.client_data.site_info.forms) m_callpy.client_data.site_info.forms = {};
        m_callpy.client_data.site_info.forms[data["form_id"]] = data["form"];

        /*if ($jcallpy.callpy_departments('_isForm')) {
            $jcallpy.callpy_departments('_create_form');
        }*/
        m_callpy.m_storage.saveData();
    };

    this.depFormDeleted = function (data)
    {
        if (m_callpy.client_data.site_info.forms && m_callpy.client_data.site_info.forms[data["form_id"]]){
            m_callpy.client_data.site_info.forms[data["form_id"]].deleted = 1;

            /*if ($jcallpy.callpy_departments('_isForm')) {
                $jcallpy.callpy_departments('_create_form');
            }*/
            m_callpy.m_storage.saveData();

        }
    };

    this.depFieldDeleted = function(data)
    {
        /*
        if (m_callpy.client_data.site_info.departments && m_callpy.client_data.site_info.departments[data["department_id"]]){
            if (m_callpy.client_data.site_info.departments[data["department_id"]].fields){
                for (var i=0; i<m_callpy.client_data.site_info.departments[data["department_id"]].fields.length; i++){
                    if (m_callpy.client_data.site_info.departments[data["department_id"]].fields[i].id == data["field_id"]){
                        m_callpy.client_data.site_info.departments[data["department_id"]].fields.splice(i,1);
                        if ($jcallpy.callpy_departments('_isForm')) {
                            $jcallpy.callpy_departments('_create_form');
                        }
                        m_callpy.m_storage.saveData();
                        break;
                    }
                }
            }
        }
        */
        if (m_callpy.client_data.site_info.forms && m_callpy.client_data.site_info.forms[data["form_id"]]){
            if (m_callpy.client_data.site_info.forms[data["form_id"]].fields){
                for (var i=0; i<m_callpy.client_data.site_info.forms[data["form_id"]].fields.length; i++){
                    if (m_callpy.client_data.site_info.forms[data["form_id"]].fields[i].id == data["field_id"]){
                        m_callpy.client_data.site_info.forms[data["form_id"]].fields.splice(i,1);
                        if ($jcallpy.callpy_departments('_isForm')) {
                            $jcallpy.callpy_departments('_create_form');
                        }
                        m_callpy.m_storage.saveData();
                        break;
                    }
                }
            }
        }
    }

    this.depAdded = function(data)
    {
        if (!m_callpy.client_data.site_info.departments) m_callpy.client_data.site_info.departments = {};
        m_callpy.client_data.site_info.departments[data["department"]["id"]] = data["department"];
        $jcallpy.callpy_departments('_create_select');
        $jcallpy.callpy_departments('_events');
        $jcallpy.callpy_departments('_set_select_department');
        m_callpy.m_storage.saveData();
    }

    this.depEdited = function(data)
    {
        if (m_callpy.client_data.site_info.departments && m_callpy.client_data.site_info.departments[data["id"]]){
            for (var field in data["data"]){
                m_callpy.client_data.site_info.departments[data["id"]][field] = data["data"][field];
            }
            $jcallpy.callpy_departments('_create_select');
            $jcallpy.callpy_departments('_events');
            $jcallpy.callpy_departments('_set_select_department');
            m_callpy.m_storage.saveData();
        }
    }

    this.departmentConsult = function(data)
    {
        if (data["type"] == 'add'){
            if (m_callpy.managers_list && m_callpy.managers_list[data["manager_id"]]){
                if (!m_callpy.managers_list[data["manager_id"]].departments) m_callpy.managers_list[data["manager_id"]].departments = [];
                m_callpy.managers_list[data["manager_id"]].departments.push(data["manager_id"]);
                //TODO: GUI: вызов перерисовки меню
                m_callpy.m_storage.saveData();
            }
        }else if (data['type'] == 'delete'){
            if (m_callpy.managers_list && m_callpy.managers_list[data["manager_id"]]){
                if (m_callpy.managers_list[data["manager_id"]].departments){
                    for (var i=0; i<m_callpy.managers_list[data["manager_id"]].departments.length; i++){
                        if (m_callpy.managers_list[data["manager_id"]].departments[i] == data["department_id"]){
                            m_callpy.managers_list[data["manager_id"]].departments.splice(i, 1);
                            break;
                        }
                    }
                }
                //TODO: GUI: вызов перерисовки меню
                m_callpy.m_storage.saveData();
            }
        }
    }

    this.setCustomUserData = function(data, encrypt)
    {
        if ((typeof data == "string") && !encrypt){
            data = $jcallpy.parseJSON(data);
        }
        $jcallpy.post(callpy_global.php_server + '/d/', {
            action: "addFormData",
            site_id: m_callpy.client_data.site_id,
            key: m_callpy.client_data.key,
            channel: m_callpy.client_data.channel,
            site: m_callpy.client_data.site,
            formType: "customForm",
            data: data,
            encrypted: !!encrypt
        }, function() {
            _this.formData({formType: "customForm", data: data});
        });
    }

    this.getCustomUserData = function()
    {
        if (m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.customForm) return m_callpy.client_data.clientInfo.formData.customForm;
        else return null;
    };

    this.setLoginData = function(data)
    {
        $jcallpy.post(callpy_global.php_server + '/d/', {
            action: "addFormData",
            site_id: m_callpy.client_data.site_id,
            key: m_callpy.client_data.key,
            channel: m_callpy.client_data.channel,
            site: m_callpy.client_data.site,
            formType: "loginForm",
            data: data
        }, function() {
            _this.formData({formType: "loginForm", data: data});
        });
    }

    this.create_listener_func = function(goal_id, element_id)
    {
        return function() {
            //UPDATED: проверка на достижение (уже этой цели)
            if (m_callpy.client_data.clientInfo.goalsData && m_callpy.client_data.clientInfo.goalsData[goal_id] && m_callpy.client_data.clientInfo.goalsData[goal_id].indexOf(element_id) != -1){
                //цель уже достигалась клиентом
            }else{
                m_callpy.m_bridge.to_fms({
                    action: "reach_goal",
                    goal_id: goal_id,
                    element_id: element_id,
                    peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0),
                    site: m_callpy.client_data.site,
                    domain: m_callpy.client_data.site,
                    referer: encodeURIComponent(window.location.href)
                });
                if (!m_callpy.client_data.clientInfo.goalsData) m_callpy.client_data.clientInfo.goalsData = {};
                if (!m_callpy.client_data.clientInfo.goalsData[goal_id]) m_callpy.client_data.clientInfo.goalsData[goal_id] = [];
                m_callpy.client_data.clientInfo.goalsData[goal_id].push(element_id);
                //UPDATED: проверка всех условий
                m_callpy.m_autos.checkAllConditions({goal_id: goal_id});
            }
        };
    }

    this.set_goals_listeners = function(goals)
    {
        for (var goal_id in goals){
            if (!goals[goal_id] || !goals[goal_id]["goals"]) continue;
            for (var i=0; i<goals[goal_id]["goals"].length; i++){
                switch (goals[goal_id]["goals"][i]["type"]){
                    case "ELEMENT":
                        if (document.querySelector(goals[goal_id]["goals"][i]["value"]) == null) continue;
                        document.querySelectorAll(goals[goal_id]["goals"][i]["value"]).addEventListener("click", _this.create_listener_func(goal_id, goals[goal_id]["goals"][i]["id"]), true);
                        break;
                    case "URL":
                        if (m_callpy.client_data.clientInfo.goalsData && m_callpy.client_data.clientInfo.goalsData[goal_id] && m_callpy.client_data.clientInfo.goalsData[goal_id].indexOf(goals[goal_id]["goals"][i]["id"]) != -1){
                            //цель уже достигалась
                        }else{
                            if (location.href.indexOf(goals[goal_id]["goals"][i]["value"])!=-1){
                                m_callpy.m_bridge.to_fms({action: "reach_goal", goal_id: goal_id, element_id: goals[goal_id]["goals"][i]["id"], peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), site: m_callpy.client_data.site, domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href)});
                                if (!m_callpy.client_data.clientInfo.goalsData) m_callpy.client_data.clientInfo.goalsData = {};
                                if (!m_callpy.client_data.clientInfo.goalsData[goal_id]) m_callpy.client_data.clientInfo.goalsData[goal_id] = [];
                                m_callpy.client_data.clientInfo.goalsData[goal_id].push(goals[goal_id]["goals"][i]["id"]);
                                //UPDATED: проверка всех условий
                                m_callpy.m_autos.checkAllConditions({goal_id: goal_id});
                            }
                        }
                        break;
                    case "FORM":
                        if (document.querySelector(goals[goal_id]["goals"][i]["value"]) == null) continue;
                        document.querySelector(goals[goal_id]["goals"][i]["value"]).addEventListener("submit", _this.create_listener_func(goal_id, goals[goal_id]["goals"][i]["id"]), true);
                        break;
                    case "INPUTCHANGE":
                        if (document.querySelector(goals[goal_id]["goals"][i]["value"]) == null) continue;
                        document.querySelector(goals[goal_id]["goals"][i]["value"]).addEventListener("input", _this.create_listener_func(goal_id, goals[goal_id]["goals"][i]["id"]), true);
                        break;
                }
            }
        }
    }

    this.new_goal = function(data)
    {
        var goal = JSON.parse(data["goal"]), obj = {};
        if (!m_callpy.client_data.site_info["goals"]) m_callpy.client_data.site_info["goals"] = {};
        m_callpy.client_data.site_info["goals"][goal["id"]] = goal;
        //TODO: навесить обработчики на элементы
        obj[goal["id"]] = goal;
        m_callpy.m_user.set_goals_listeners(obj);
    };

    /**
     * Метод для переключения на диалог, либо на основную переписку
     * @param data
     */

    this.select_new_dialog = function(data, callback)
    {
        if (!m_callpy.client_data.dialogs[data["dialog_id"]]){
            console.log("Ошибка при переключении на диалог: нет информации по диалогу "+data["dialog_id"]);
            return;
        }

        m_callpy.client_data.dialog_id = data["dialog_id"];
        //0 - основная переписка
        if (data["dialog_id"] != 0){

            //данные по составу участников диалога и по переписке получаем только при переключении на диалог
            var historyExists = !!(m_callpy.m_chat.history_dialogs && m_callpy.m_chat.history_dialogs[data["dialog_id"]]),
                participantsExist = !!(m_callpy.client_data.dialogs_participants && m_callpy.client_data.dialogs_participants[data["dialog_id"]]);

            m_callpy.m_bridge.to_fms(
                m_callpy.m_message.create_message("select_new_dialog", {
                    "dialog_id": m_callpy.client_data.dialog_id,
                    "site_id": m_callpy.client_data.site_id,
                    "part_id": m_callpy.client_data.key,
                    "part_site_id": m_callpy.client_data.site_id,
                    "participants": !participantsExist,
                    "history": !historyExists
                    //TODO: для консультанта в этом запросе требуется передать в channel id его канала консультанта (для предотвращения подделки запроса)
                }), function(rdata){
                    rdata = JSON.parse(rdata);

                    if (!historyExists){
                        m_callpy.m_chat.history_dialogs[data["dialog_id"]] = rdata["history"];
                    }
                    if (!participantsExist){
                        m_callpy.client_data.dialogs_participants[data["dialog_id"]] = rdata["participants"];
                    }
                    m_callpy.m_storage.saveData();

                    //TODO: сброс количества непрочитанных сообщений на 0 (когда будут соответствующие данные в диалогах)
                    m_callpy.client_data.dialogs[m_callpy.client_data.dialog_id]["unread"] = 0;

                    console.log('TODO: GUI: переключение на диалог');
                    callback();
            });


        }else{

            //TODO: GUI: Сменить состояние на состояние основной переписки. Вывести заново все сообщения переписки

        }

    };

};